const categorieDepenseOptions = [
  {
    key: '1',
    value: "Main d'oeuvre temporaire",
    text: "Main d'oeuvre temporaire",
  },
  { key: '2', value: 'Tracteur', text: 'Tracteur' },
  { key: '3', value: 'Grosse mécanisation', text: 'Grosse mécanisation' },
  { key: '4', value: 'Intrants chimiques', text: 'Intrants chimiques' },
  { key: '5', value: 'Fumier', text: 'Fumier' },
  { key: '6', value: 'Paille', text: 'Paille' },
  { key: '7', value: 'Foin', text: 'Foin' },
  { key: '8', value: 'Concentrés', text: 'Concentrés' },
  { key: '9', value: 'Irrigation', text: 'Irrigation' },
  { key: '10', value: 'Semences', text: 'Semences' },
  { key: '11', value: 'Divers', text: 'Divers' },
];

export default categorieDepenseOptions;
